import React from 'react';
import PropTypes from 'prop-types';

import { ResponsiveLine } from '@nivo/line';

export default function EquityCurveChart({ data }) {
    // Transform data for Nivo
    const chartData = [
        {
            id: 'equity',
            data: data.map((item, index) => ({
                x: index + 1,
                y: item.totalAccumulatedPnL
            }))
        }
    ];

    return (
        <div style={{ height: 300 }}>
            <ResponsiveLine
                data={chartData}
                margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
                xScale={{ type: 'point' }}
                yScale={{
                    type: 'linear',
                    min: 'auto',
                    max: 'auto',
                    stacked: false,
                    reverse: false
                }}
                curve="monotoneX"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Trade Number',
                    legendOffset: 45,
                    legendPosition: 'middle'
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Cumulative P&L',
                    legendOffset: -50,
                    legendPosition: 'middle',
                    format: (value) => `$${value.toFixed(0)}`
                }}
                colors={{ scheme: 'category10' }}
                pointSize={6}
                pointColor={{ theme: 'background' }}
                pointBorderWidth={2}
                pointBorderColor={{ from: 'serieColor' }}
                pointLabelYOffset={-12}
                useMesh
                enableArea
                areaOpacity={0.1}
                tooltip={({ point }) => (
                    <div
                        style={{
                            background: 'white',
                            padding: '9px 12px',
                            border: '1px solid #ccc',
                            borderRadius: 4
                        }}
                    >
                        <strong>Trade {point.data.x}</strong>
                        <br />
                        P&L: ${point.data.y.toFixed(2)}
                    </div>
                )}
            />
        </div>
    );
}

EquityCurveChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string.isRequired,
            totalAccumulatedPnL: PropTypes.number.isRequired
        })
    ).isRequired
};
